import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "page-box-title title1" }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { class: "page-tab" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "page-select" }
const _hoisted_8 = { class: "el-dropdown-link" }
const _hoisted_9 = { class: "el-dropdown-link" }
const _hoisted_10 = { class: "el-dropdown-link" }
const _hoisted_11 = { class: "history-box" }
const _hoisted_12 = {
  key: 0,
  class: "page-inner-box empty"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "history-box-item-top" }
const _hoisted_15 = { class: "title1" }
const _hoisted_16 = { class: "history-box-item-tag" }
const _hoisted_17 = { class: "history-box-item-inner" }
const _hoisted_18 = { class: "history-box-item-bottom" }
const _hoisted_19 = { style: {"display":"flex"} }
const _hoisted_20 = { class: "history-box-bottom-icon" }
const _hoisted_21 = {
  class: "history-box-bottom-icon",
  style: {"margin-left":"8px"}
}
const _hoisted_22 = { class: "history-box-bottom-icon" }
const _hoisted_23 = { style: {"text-align":"center","margin-top":"10px"} }
const _hoisted_24 = { class: "page-inner page-right" }
const _hoisted_25 = {
  key: 0,
  class: "page-inner-box empty"
}
const _hoisted_26 = { class: "page-box-title2 title1 source-title" }
const _hoisted_27 = { class: "page-inner-box" }
const _hoisted_28 = {
  key: 2,
  class: "result-footer"
}
const _hoisted_29 = { style: {"display":"flex"} }
const _hoisted_30 = { class: "page-inner page-left" }
const _hoisted_31 = { style: {"margin":"20px 0"} }
const _hoisted_32 = { class: "page-inner page-right" }
const _hoisted_33 = {
  key: 0,
  class: "page-box-title2 title1"
}
const _hoisted_34 = {
  key: 1,
  class: "page-box-correct"
}
const _hoisted_35 = {
  key: 2,
  class: "source-inner"
}
const _hoisted_36 = { class: "source-inner-checkAll" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { style: {"padding":"10px"} }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 3,
  class: "page-inner-box empty"
}
const _hoisted_44 = {
  key: 4,
  class: "result-footer"
}
const _hoisted_45 = { style: {"display":"flex"} }

import clipBoard from "vue-clipboard3"
import { ref, reactive, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { compMaterialStreamingV2, saveSreamResult, checkAiCall, getPubMaterial, materialGrade, materialUnit, materialCollectAi, materialUnCollect, materialCollect, getMaterialDetail, getVoiceDataOss } from "@/api/composition.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import { formatterEvent } from "@/utils/common.js"
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { Search } from '@element-plus/icons-vue'
import Speech from 'speak-tts'
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'sourceMaterial',
  setup(__props) {

const store = useStore();
let { toClipboard } = clipBoard()

const speech = new Speech();

// 列表
const isEdit = ref(false)
const tabActive = ref('all')
const keyword = ref('')
const tableList = ref([])
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 10
})
const pageShow = ref(true)
const detailInfo = ref({})
const detailIndex = ref(0)
const gradeArr = ref([])
const unitArr = ref([])
const sourceInfo = ref({})
const gradeInfo = ref({})
const unitInfo = ref({})

const tabList = [
    {
        label: '全部',
        value: 'all'
    },
    {
        label: '热门词汇',
        value: '01'
    },
    {
        label: '优秀句式',
        value: '02'
    },
    {
        label: '精彩段落',
        value: '03'
    },
]
const sourceArr = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '开悟作文',
        value: '01'
    }, {
        label: '其他书籍',
        value: '02'
    }
]


function tabChange(item) {
    if (item.value == tabActive.value) return
    tabActive.value = item.value
    handleCurrentChange(1)
}

function getList() {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size,
        type: tabActive.value == 'all' ? '' : tabActive.value,
        grade: gradeInfo.value.value,
        origin: sourceInfo.value.value,
        unit: unitInfo.value.value,
        title: keyword.value,
    }
    pageInfo.value.total = 0;
    tableList.value = []
    getPubMaterial(params).then((res: any) => {
        tableList.value = (res.data.records || []).map(item => {
            return {
                ...item,
                checked: false
            }
        })
        pageInfo.value.total = res.data.total || 0;
        if (tableList.value.length) {
            itemClick(tableList.value[0], 0)
        } else {
            detailInfo.value = {}
            detailIndex.value = 0
        }
    })
}

function typeFormat(val) {
    return formatterEvent(tabList, val)
}

function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}

function itemClick(item, index) {
    detailIndex.value = index
    getMaterialDetail({ type: 2, id: item.id }).then(res => {
        detailInfo.value = res.data;
    })
}

function sourceCommand(item) {
    if (sourceInfo.value.value == item.value) return;
    gradeInfo.value = {}
    unitInfo.value = {}
    if (item.label == '全部') {
        sourceInfo.value = {
            label: '来源选择',
            value: ''
        }

    } else {
        sourceInfo.value = item;
        if (item.value == '01') {
            materialGrade().then(res => {
                let arr = (res.data || []).map(info => {
                    return {
                        label: info,
                        value: info
                    }
                })
                gradeArr.value = [
                    {
                        label: '全部',
                        value: ''
                    },
                    ...arr,
                ]
            })
        }
    }
    handleCurrentChange(1)
}

function gradeCommand(item) {
    if (gradeInfo.value.value == item.value) return;
    unitInfo.value = {}
    if (item.label == '全部') {
        gradeInfo.value = {
            label: '年级选择',
            value: ''
        }
    } else {
        gradeInfo.value = item;
        materialUnit(item.value).then(res => {
            let arr = (res.data || []).map(info => {
                return {
                    label: info,
                    value: info
                }
            })
            unitArr.value = [
                {
                    label: '全部',
                    value: ''
                },
                ...arr,
            ]
        })
    }
    handleCurrentChange(1)
}

function unitCommand(item) {
    if (unitInfo.value.value == item.value) return;
    if (item.label == '全部') {
        unitInfo.value = {
            label: '年级选择',
            value: ''
        }
    } else {
        unitInfo.value = item;
    }
    handleCurrentChange(1)
}

function collectDetailEvent() {
    const api = detailInfo.value.isCollect ? materialUnCollect : materialCollect;
    api(detailInfo.value.id).then(res => {
        ElMessage.success(detailInfo.value.isCollect ? '取消收藏' : '收藏成功')
        getList()
    })
}

onMounted(() => {
    getList()


    speech.init({
        volume: 1,
        lang: 'zh-CN',
        rate: 1.4,
        pitch: 1.4,
    }).then(() => {
        console.log('语音引擎初始化成功');
    });
})





// 编辑
const pickerColumns = [
    {
        label: '小学',
        value: '小学'
    },
    {
        label: '初中',
        value: '初中'
    },
    {
        label: '高中',
        value: '高中'
    }
]
const resultTabList = [
    {
        label: '好词',
        value: 'ci'
    },
    {
        label: '好句',
        value: 'ju'
    },
    {
        label: '好段',
        value: 'duan'
    },
]

const formData = ref({
    correctText: '',
    correctGrade: ''
})
let controller = null
let resultInfo = ref({})
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const aiStart = ref(false)
const popupShow = ref(false)
const checkAll = ref(false)
const activeName = ref('ci')
const voiceStatus = ref(0) //1 语音正在播放 2语音暂停 0没有语音 4语音播放完成
let musicContext = new Audio()
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function submitEvent() {
    const { correctText, correctGrade } = formData.value;
    if (!correctText) {
        return ElMessage.warning('请填写素材要求');
    }
    if (!correctGrade) {
        return ElMessage.warning('请选择学段');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}

function backEvent() {
    isEdit.value = false
    resultInfo.value = {}
    formData.value = {
        correctText: '',
        correctGrade: ''
    }
    voiceStatus.value = 0;
}

function getAi() {
    const { correctText, correctGrade } = formData.value;
    const params = {
        grade: correctGrade,
        term: '',
        title: correctText,
    }
    aiStart.value = true
    popupShow.value = true
    voiceStatus.value = 0;
    fetchRequest({
        url: compMaterialStreamingV2,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const { signal } = controller;
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const chunkInfo = JSON.parse(chunkText)
            console.log(chunkInfo)
            let obj = {}
            for (let key in chunkInfo.data) {
                const arr = chunkInfo.data[key];
                obj[key] = []
                let info = [],
                    num = 0;
                arr.forEach(item => {
                    const textArr = item.text;
                    textArr.forEach(textItem => {
                        const index = textItem.indexOf('：')
                        let textObj = {}
                        if (index > -1) {
                            const textStr = textItem.split('：')
                            textObj.title = textStr[0];
                            textObj.content = textStr[1];
                            if (key == 'ci') {
                                textObj.id = 'ci_' + num;
                            } else if (key == 'ju') {
                                textObj.id = 'ju_' + num;
                            } else if (key == 'duan') {
                                textObj.id = 'duan_' + num;
                            }
                        } else {
                            if (key == 'ci') {
                                textObj.title = '其他类词语';
                                textObj.id = 'ci_' + num;
                            } else if (key == 'ju') {
                                textObj.title = '其他类句';
                                textObj.id = 'ju_' + num;
                            } else if (key == 'duan') {
                                textObj.title = '其他类段落';
                                textObj.id = 'duan_' + num;
                            }
                            textObj.content = textItem;
                        }
                        num++;
                        textObj.checked = false;
                        obj[key].push(textObj)
                    })
                })
            }
            resultInfo.value = obj;
        } else {
            aiStart.value = false;
        }
    }
}

async function copyEvent() {
    try {
        const checkList = resultInfo.value[activeName.value].filter(item => {
            return item.checked
        })
        if (!checkList || !checkList.length) {
            return ElMessage.warning('请选择想收藏的词句段！')
        }
        let text = ''
        checkList.forEach(item => {
            text = text + item.content + '\n'
        })
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

async function copyDetailEvent() {
    try {
        let text = ''
        let obj = detailInfo.value
        if (Object.keys(obj).length) {
            text = obj.content
        }
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

function collectEvent() {
    let obj = {
        'ci': [],
        'ju': [],
        'duan': []
    }
    const checkList = resultInfo.value[activeName.value].filter(item => {
        return item.checked
    })
    if (!checkList || !checkList.length) {
        return ElMessage.warning('请选择想收藏的词句段！')
    }
    checkList.forEach(item => {
        obj[activeName.value].push(item)
    })
    materialCollectAi(obj).then(res => {
        ElMessage.success('收藏成功')
    })

}

function handleCheckAllChange(val) {
    resultInfo.value[activeName.value].map(item => {
        item.checked = val
        return item
    })
    checkAll.value = val
}

function handleCheckedChange(val, index) {
    resultInfo.value[activeName.value][index].checked = val
    const len = resultInfo.value[activeName.value].length;
    let checkLen = 0;
    resultInfo.value[activeName.value].forEach(item => {
        if (item.checked) {
            checkLen++
        }
    })
    if (checkLen > 0 && checkLen == len) {
        checkAll.value = true
    } else {
        checkAll.value = false
    }
}

function resultTabChange(val) {
    resultInfo.value[activeName.value].map(item => {
        item.checked = false
        return item
    })
    checkAll.value = false
    activeName.value = val;
    speech.cancel()
    voiceStatus.value = 0
}

function transVoice() {
    if (aiStart.value) {
        return ElMessage.warning('独家算法，请稍等！');
    }
    if (voiceStatus.value == 1) {
        speech.pause()
        voiceStatus.value = 2
        return
    }
    if (voiceStatus.value == 2) {
        speech.resume()
        voiceStatus.value = 1
        return
    }
    if (Object.keys(resultInfo.value).length) {
        let text = ''
        const loading = ElLoading.service({
            lock: true,
            text: '语音即将播放！',
            background: 'rgba(255, 255, 255, 0.7)',
        })
        resultInfo.value[activeName.value].map(item => {
            text += `${item.title}\n`
            text += `${item.content}\n`
        })
        speech.speak({
            text: text,
            listeners: {
                onstart: () => {
                    loading.close()
                    voiceStatus.value = 1;
                },
                onend: () => {
                    voiceStatus.value = 4
                }
            }
        });
    }
}

onBeforeUnmount(() => {
    controller && controller.abort()
    speech && speech.cancel()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_Clock = _resolveComponent("Clock")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_Star = _resolveComponent("Star")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Microphone = _resolveComponent("Microphone")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("span", null, " 素材库 ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: keyword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            placeholder: "请输入关键词",
            "suffix-icon": _unref(Search),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (handleCurrentChange(1)))
          }, null, 8, ["modelValue", "suffix-icon"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (item) => {
          return _createElementVNode("div", {
            key: item.value,
            class: _normalizeClass(['page-tab-item',tabActive.value==item.value?'page-tab-item-active':'']),
            onClick: ($event: any) => (tabChange(item))
          }, _toDisplayString(item.label), 11, _hoisted_6)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_row, {
          gutter: 20,
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, {
                  "max-height": "350px",
                  onCommand: sourceCommand
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sourceArr, (item) => {
                          return _createVNode(_component_el_dropdown_item, {
                            key: item.value,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"])
                        }), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(sourceInfo.value.label || '来源选择') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, {
                  "max-height": "350px",
                  onCommand: gradeCommand
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradeArr.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: item.value,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(gradeInfo.value.label || '年级选择') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, { onCommand: unitCommand }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitArr.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: item.value,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(unitInfo.value.label || '单元选择') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        (!tableList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[10] || (_cache[10] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1),
              _createElementVNode("div", null, "暂无数据", -1)
            ])))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(tableList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['history-box-item',detailIndex.value==index?'active':'']),
                key: item.artiCorrectingId,
                onClick: ($event: any) => (itemClick(item,index))
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: _normalizeClass([`classType${item.type}`])
                    }, _toDisplayString(typeFormat(item.type)), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.content), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Menu)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "来源：" + _toDisplayString(item.origin=='01'?'开悟作文':'其他书籍'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_icon, { size: "14" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_StarFilled)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "收藏：" + _toDisplayString(item.collectNum), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_el_icon, { size: "14" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Clock)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, "发布：" + _toDisplayString(item.createTime), 1)
                  ])
                ])
              ], 10, _hoisted_13))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        (pageShow.value)
          ? (_openBlock(), _createBlock(_component_el_config_provider, {
              key: 0,
              locale: _unref(zhCn)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_pagination, {
                  "current-page": pageInfo.value.current,
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageInfo.value.current) = $event)),
                  "page-size": pageInfo.value.size,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageInfo.value.size) = $event)),
                  total: pageInfo.value.total,
                  "page-sizes": [10, 20, 30, 50],
                  layout: "total, sizes,jumper",
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ]),
              _: 1
            }, 8, ["locale"]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !isEdit.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_24, [
      (!Object.keys(detailInfo.value).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[11] || (_cache[11] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "暂无数据", -1)
          ])))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_26, [
              _createTextVNode(_toDisplayString(detailInfo.value.title) + " ", 1),
              _createElementVNode("div", {
                class: "source-title-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (isEdit.value=true))
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("span", null, "Ai素材生成", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_27, _toDisplayString(detailInfo.value.content), 1)
          ], 64)),
      (Object.keys(detailInfo.value).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "correct-tip" }, [
              _createElementVNode("span", { class: "activeColor" }, "*"),
              _createElementVNode("span", null, "部分内容由AI生成")
            ], -1)),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: "result-footer-btn",
                onClick: collectDetailEvent
              }, [
                (!detailInfo.value.isCollect)
                  ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0,
                      size: "18"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Star)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, {
                      key: 1,
                      color: "#f9ae3d",
                      size: "18"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_StarFilled)
                      ]),
                      _: 1
                    })),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "收藏素材", -1))
              ]),
              _createVNode(_component_el_button, {
                color: "#ef8b25",
                class: "footer-btn1",
                size: "small",
                onClick: copyDetailEvent,
                style: {"float":"right"}
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("复制素材")
                ])),
                _: 1,
                __: [14]
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !isEdit.value]
    ]),
    (isEdit.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_30, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "page-box-title title1" }, "作文素材", -1)),
            _createElementVNode("div", null, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "correct-tip" }, [
                _createElementVNode("span", { class: "activeColor" }, "*提示："),
                _createElementVNode("span", null, "建议在输入框中输入您想写的作文标题")
              ], -1)),
              _createVNode(_component_el_row, {
                gutter: 10,
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.correctGrade,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.correctGrade) = $event)),
                        placeholder: "请选择学段"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pickerColumns, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: item.label
                            }, null, 8, ["value", "label"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                gutter: 10,
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        maxlength: "5000",
                        modelValue: formData.value.correctText,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.correctText) = $event)),
                        type: "textarea",
                        rows: 6,
                        placeholder: "输入要生成的作文素材的要求"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        disabled: aiStart.value,
                        style: {"width":"100%"},
                        color: "#ef8b25",
                        class: "footer-btn1",
                        onClick: submitEvent
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("AI生成作文素材")
                        ])),
                        _: 1,
                        __: [17]
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        style: {"width":"100%"},
                        type: "info",
                        class: "footer-btn1",
                        onClick: backEvent
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("返回")
                        ])),
                        _: 1,
                        __: [18]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            (!Object.keys(_unref(resultInfo)).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, "作文素材生成结果"))
              : _createCommentVNode("", true),
            (Object.keys(_unref(resultInfo)).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_el_tabs, {
                    modelValue: activeName.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeName).value = $event)),
                    class: "demo-tabs",
                    onTabChange: resultTabChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(resultTabList, (item) => {
                        return _createVNode(_component_el_tab_pane, {
                          label: item.label,
                          name: item.value,
                          key: item.value
                        }, null, 8, ["label", "name"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (activeName.value in _unref(resultInfo) && _unref(resultInfo)[activeName.value].length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_el_checkbox, {
                      modelValue: checkAll.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((checkAll).value = $event)),
                      onChange: handleCheckAllChange
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode(" 全选素材 ")
                      ])),
                      _: 1,
                      __: [20]
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", {
                      onClick: transVoice,
                      class: "source-inner-voice"
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Microphone)
                        ]),
                        _: 1
                      }),
                      (voiceStatus.value==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "语音继续"))
                        : (voiceStatus.value==1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "语音暂停"))
                          : (voiceStatus.value==4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "语音重播"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_40, "转语音"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo)[activeName.value], (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id
                      }, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: item.checked,
                          "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                          onChange: (val)=>handleCheckedChange(val,index)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                        _createElementVNode("div", {
                          class: "result-content",
                          onClick: ($event: any) => (handleCheckedChange(!item.checked,index))
                        }, _toDisplayString(item.content), 9, _hoisted_42)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!Object.keys(_unref(resultInfo)).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[21] || (_cache[21] = [
                  _createElementVNode("img", { src: _imports_0 }, null, -1),
                  _createElementVNode("div", null, "结果将在此处展示！", -1)
                ])))
              : _createCommentVNode("", true),
            (Object.keys(_unref(resultInfo)).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "correct-tip" }, [
                    _createElementVNode("span", { class: "activeColor" }, "*"),
                    _createElementVNode("span", null, "部分内容由AI生成")
                  ], -1)),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", {
                      class: "result-footer-btn",
                      onClick: collectEvent
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Star)
                        ]),
                        _: 1
                      }),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "收藏素材", -1))
                    ]),
                    _createVNode(_component_el_button, {
                      color: "#ef8b25",
                      class: "footer-btn1",
                      size: "small",
                      disabled: aiStart.value,
                      onClick: copyEvent,
                      style: {"float":"right"}
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("复制素材")
                      ])),
                      _: 1,
                      __: [23]
                    }, 8, ["disabled"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true),
    (popupShow.value)
      ? (_openBlock(), _createBlock(AIpopup, {
          key: 1,
          popupShow: popupShow.value,
          cancelShow: false,
          onCancel: aiCancel
        }, null, 8, ["popupShow"]))
      : _createCommentVNode("", true)
  ]))
}
}

})